module.exports = __webpack_public_path__ + "img/Woveon2.ff58c43c.svg";